import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ProfileCard from "./ProfileCard";
import "../../styles/MemberProfile.css";

const ProfileEventsSection = () => {
  const navigate = useNavigate();

  return (
    <ProfileCard title="Events" hideActions>
      <div className="discover-events">
        <p className="events-title">Attend your first event</p>

        <p className="events-subtitle">
          Join an event to start connecting others
        </p>

        <Button className="cta-button mt-3" onClick={() => navigate("/events")}>
          Discover events
        </Button>
      </div>
    </ProfileCard>
  );
};

export default ProfileEventsSection;
